export default {
    text: 'Admin',
    path: '/admin',
    icon: 'admin.svg',
    permissions: true,
    children: [
        {
            text: 'References and Tags',
            path: '/admin/tags-and-references',
            permissions: {
                CTAG: 'READ'
            },
            children: [
                {
                    text: 'Tags',
                    path: '/admin/tags',
                    children: []
                },
                {
                    text: 'Tag groups',
                    path: '/admin/tags/groups',
                    children: [],
                },
                {
                    text: 'Reference groups',
                    path: '/admin/contentreferencegroups',
                    children: [],
                    permissions: true
                },
                {
                    text: 'Visibility settings',
                    path: '/admin/tags-and-references/visibility',
                    children: []
                }
            ]
        },
        {
            text: 'Metadata',
            path: '/admin/metadata',
            permissions: true,
            children: [
                {
                    text: 'Metadata keys',
                    path: '/admin/metadata/config',
                    children: [],
                    permissions: {
                        CMETADATA_CONFIG: 'READ'
                    }
                },
                {
                    text: 'Metadata values',
                    path: '/admin/metadata/edit',
                    permissions: {
                        CMETADATA: 'READ'
                    },
                    children: []
                }
            ]
        },
        {
            text: 'Roles',
            path: '/admin/roles',
            permissions: {
                AROLE: 'READ'
            }
        },
        {
            text: 'Territories',
            path: '/admin/territories',
            permissions: {
                OTERRITORY: 'READ'
            }
        },
        {
            text: 'Settings',
            path: '/admin/settings',
            permissions: {
                ACONFIGURATION: 'READ'
            }
        }
    ]
};
